import React, { useEffect, forwardRef } from 'react';
import { Form } from 'semantic-ui-react';

const TextAreaInput = forwardRef(({
  value,
  onChange,
  onKeyDown, // Add this prop
  setFocus,
  placeholder,
  name,
}, ref) => {

  // Automatically set focus if setFocus is true
  useEffect(() => {
    if (setFocus && ref?.current) {
      ref.current.focus();
    }
  }, [setFocus, ref]);

  return (
    <Form.Field>
      <textarea
        ref={ref} // Directly attach the forwarded ref
        name={name}
        className="chatInput"
        placeholder={placeholder || "Type your message..."}
        value={value} // Controlled by parent
        onChange={onChange} // Controlled by parent
        onKeyDown={onKeyDown} // Attach onKeyDown here
        rows={1} // Start with 1 row
      />
    </Form.Field>
  );
});

export default TextAreaInput;
